import { defineComponent, h, useAttrs } from 'vue'
import { VWindow } from 'vuetify/components'

export default defineComponent({
  name: 'VTabsItemsCompat',
  compatConfig: {
    RENDER_FUNCTION: false,
    COMPONENT_V_MODEL: false,
    INSTANCE_ATTRS_CLASS_STYLE: false
  },
  inheritAttrs: false,

  setup(_, { slots }) {
    const attrs = useAttrs()

    return () => h(VWindow, attrs, slots)
  }
})
